module.exports = __webpack_public_path__ + "static/annual-report-2017-18-ebe6dac1eaf29123c0e7da15cd1e1ae4.pdf";